/**
 * @hidden
 */
export var DATA_ACTION;
(function (DATA_ACTION) {
    DATA_ACTION["remove"] = "remove";
    DATA_ACTION["add"] = "add";
    DATA_ACTION["reorder"] = "reorder";
})(DATA_ACTION || (DATA_ACTION = {}));
/**
 * @hidden
 */
export var dataReducer = function (state, action) {
    switch (action.type) {
        case DATA_ACTION.add:
            // TODO v2
            break;
        case DATA_ACTION.remove:
            return state.filter(function (i) { return i[action.valueField] !== action.payload; });
        case DATA_ACTION.reorder:
            // TODO v2
            break;
        default:
            return state;
    }
};
//# sourceMappingURL=data-reducer.js.map